import { ReactNode } from 'react';
import { StyledContainer } from './gradient-background.styles';
export const GradientBackground = ({
  children
}: {
  children: ReactNode;
}) => <StyledContainer data-sentry-element="StyledContainer" data-sentry-component="GradientBackground" data-sentry-source-file="gradient-background.tsx">{children}</StyledContainer>;